import ExtendedLiquid from '../../services/ExtendedLiquid';
import ContentManagementInterface from '../../models/ContentManagementInterface';
import { FundOpportunityEOIController } from './controller';

// EOI workflow and referral-invitation handlers live in sibling modules; re-exported
// here so existing `import * as contentEditingHandlers` consumers keep one entry point.
export * from './eoiActionHandlers';
export * from './invitationHandlers';

/** Renders the stored template (Liquid placeholders filled from the fund) into state. */
export function dataRead(ctx: FundOpportunityEOIController, template: string): Promise<void> {
  return new Promise<void>((resolve) => {
    const engine = new ExtendedLiquid();
    const renderedTemplate = engine.parseAndRenderSync(template, {
      model: ctx.state.fundOpportunity!,
    });
    const contentManagementInterface = JSON.parse(renderedTemplate) as ContentManagementInterface;

    // Functional updater so this merges into the latest state rather than a
    // stale snapshot (e.g. loadingCustodianStatus resolving while content loads).
    ctx.setState(
      (prev) => ({ ...prev, contentManagementInterface, newTemplate: false }),
      () => resolve(),
    );
  });
}
